import React from "react";
import { formatDate } from '../../utils/formatDate'

import { Button } from "../../components/Wrappers";
import MUIDataTable from "../../components/DataTable"
import AddToolButton from "../../components/DataTable/AddToolButton"
import HouseholdHeader from './HouseholdHeader'
import UpsertForm from '../householdCases/UpsertForm'
import HouseholdCallLogs from './CallLogs'
import HouseholdAppointments from './Appointments'
import LoadingState from '../../components/LoadingState'

import { useParams } from "react-router-dom";
import { useOpenDialog } from "../../context/DialogContext";
import {useHouseholdHouseholdCases,useHousehold} from "../../apis"

const Household = ({history}) => {
    const {householdId} = useParams()    
    const openDialog = useOpenDialog()
    
    
    const openCase = (householdCase) => {
        history.push(`/app/household/${householdId}/householdCase/${householdCase.id}`)
    }
         
    const {household,isLoading,isError : householdError,mutate} = useHousehold(householdId)

    const {householdCases,isLoading:isLoadingCases,isError: casesError,mutate: mutateCases} = useHouseholdHouseholdCases(householdId)
     
    const escalationMap = {1:"Regular",2:"Urgent"}    
    const options = {
        selectableRows:"none",
        textLabels: { body: { noMatch: casesError ? "Cases could not be loaded." : isLoadingCases ? "Loading cases..." : "No cases exist for this household." } },
        customToolbar: () => {
            return (
                <AddToolButton handleClick={() => openDialog("Open New Case" , <UpsertForm household={household} onSaved={mutateCases} /> )}  />
            );
        }
    }
    const columns = [
        
        {name:"caseTypeName" , label:"Case Type"},
        {name:"createdAt", label: "Date" , options : {customBodyRender: value => formatDate(value,"MMM do, yyyy")}},
        {name:"statusName" , label:"Status"},
        {name:"assignedToEmail" , label:"Assigned To"},
        {name:"volunteers" , label:"Volunteer", options : {customBodyRender: (values) => Array.isArray(values) ? values.filter(Boolean).map(volunteer => [volunteer.firstName, volunteer.lastName].filter(Boolean).join(" ")).join(", ") : ""}},
        {name:"escalationLevel" , label:"Escalation", options : {customBodyRender: value => escalationMap[value]}},
        {name:"" , options : {
            filter: false,
            sort: false,
            empty: true,
            customBodyRenderLite: (dataIndex) => {
                const row = householdCases[dataIndex];
                if (!row) return ""
                return (
                    <Button variant="contained" size="small" color="success" onClick={() => openCase(row)}>View</Button>
                )
            } 
        } }
    ];

    if (householdError) return <div role="alert">The household could not be loaded. <Button onClick={() => mutate()}>Retry</Button></div>
    if (isLoading && !household) return <LoadingState title="Household" />
    if (!household) return <div>Household not found.</div>

    return (
        <div>
            {!!casesError && <div role="alert">The household cases could not be loaded. <Button onClick={() => mutateCases()}>Retry</Button></div>}
            {!!household && 
                <>
                    <HouseholdHeader household={household} mutate={mutate} />                
                    <br />
                    <MUIDataTable title={"Household Cases"} loading={isLoadingCases && !casesError} data={householdCases} columns={columns} options={options} />
                    <br />
                    {/* Requirement 11.1 - the household's appointments, past and future */}
                    <HouseholdAppointments household={household} />
                    <br />
                    {!!household && <HouseholdCallLogs household={household} />}
                </>
            }
        </div>
    )
}

export default Household
